import type { HTMLAttributes } from "react";
import { cn } from "@/utils/cn";

/**
 * Skeleton — usado em toda a aplicação como estado de carregamento.
 * Especificação exige: "Nunca utilizar spinner simples. Criar Skeleton Loading."
 * O Spinner (ver Spinner.tsx) fica reservado só para ações pontuais dentro de
 * botões, nunca para carregamento de tela/lista inteira.
 */
function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("skeleton-shimmer rounded-xl", className)} {...props} />;
}

function SkeletonText({ lines = 1, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={cn("h-3.5", i === lines - 1 && lines > 1 ? "w-2/3" : "w-full")} />
      ))}
    </div>
  );
}

function SkeletonCard() {
  return (
    <div className="rounded-2xl border border-border bg-card p-5 shadow-soft">
      <div className="flex items-center gap-3">
        <Skeleton className="h-11 w-11 rounded-full" />
        <div className="flex-1">
          <Skeleton className="h-3.5 w-1/2" />
          <Skeleton className="mt-2 h-3 w-1/3" />
        </div>
      </div>
      <SkeletonText lines={2} className="mt-4" />
    </div>
  );
}

export { Skeleton, SkeletonText, SkeletonCard };
